export interface DiagnosticReport {
  version: string;
  timestamp: string;
  userAgent: string;
  screenResolution: string;
  language: string;
  diagnostics: Record<string, any>;
  duration: number;
}

const DEFAULT_BACKENDS = [
  "https://nettool-va-ali.rivergame.net",
  "https://nettool-va-gcp.topwargame.com",
  "https://nettool-va-cf.topwarapp.com",
  "https://nettool-va-aws.topwargame.com",
];

let sortedBackends: string[] = DEFAULT_BACKENDS;

export function setBackendOrder(backends: string[]): void {
  sortedBackends = backends;
}

// Read the game id from the page URL (`?gid=` or `?_gid_=`), if present.
function getGid(): string | null {
  const params = new URLSearchParams(window.location.search);
  const gid = params.get("gid") || params.get("_gid_");
  return gid && gid.trim() ? gid.trim() : null;
}

async function getPresignedUrl(): Promise<{ uploadUrl: string; reportId: string } | null> {
  const gid = getGid();
  const qs = gid ? `?gid=${encodeURIComponent(gid)}` : "";
  for (const base of sortedBackends) {
    try {
      const res = await fetch(`${base}/api/s3-presign${qs}`, { method: "POST", signal: AbortSignal.timeout(5000) });
      if (res.ok) return await res.json();
    } catch {}
  }
  return null;
}

export async function uploadReport(report: DiagnosticReport): Promise<{ success: boolean; reportId: string | null; error?: string }> {
  const presign = await getPresignedUrl();
  if (!presign) {
    return { success: false, reportId: null, error: "Failed to get upload URL" };
  }

  try {
    const uploadRes = await fetch(presign.uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(report),
      signal: AbortSignal.timeout(15000),
    });
    if (uploadRes.ok) {
      return { success: true, reportId: presign.reportId };
    }
    return { success: false, reportId: null, error: `Upload failed: ${uploadRes.status}` };
  } catch (e: any) {
    return { success: false, reportId: null, error: e.message || "Upload failed" };
  }
}

